/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'monitor': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M295.959 949.85h431.304V1024H295.959zM511.61 825.105c-227.478 0-412.552-185.074-412.552-412.552S284.133 0 511.61 0s412.552 185.074 412.552 412.552S739.089 825.104 511.61 825.104zm0-750.945c-186.591 0-338.393 151.802-338.393 338.393S325.02 750.945 511.611 750.945s338.402-151.802 338.402-338.393S698.202 74.159 511.611 74.159z" _fill="#333"/><path pid="1" d="M415.576 412.552a96.045 96.045 0 1 0 192.09 0 96.045 96.045 0 1 0-192.09 0z" _fill="#C6C6C6"/>'
  }
})
